<template>
  <v-card>
    <ValidationObserver
      ref="form"
      tag="form"
      @submit.prevent="changePassword"
    >
      <v-toolbar color="blue-grey lighten-5">
        <v-toolbar-title>{{ $t('CHANGE_PASSWORD') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <ValidationProvider
          rules="required"
          vid="current_password"
          :name="$t('fields.current_password').toLowerCase()"
          v-slot="{ errors }"
        >
          <v-text-field
            type="password"
            v-model=" form.current_password"
            :error-messages="errors"
            :label="$t('fields.current_password')"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
          rules="required|min:8|max:60"
          vid="password"
          :name="$t('fields.password').toLowerCase()"
          v-slot="{ errors }"
        >
          <v-text-field
            type="password"
            v-model=" form.password"
            :counter="60"
            :error-messages="errors"
            :label="$t('fields.new_password')"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
          rules="required|confirmed:password|min:8|max:60"
          vid="confirm_password"
          :name="$t('fields.confirm_password').toLowerCase()"
          v-slot="{ errors }"
        >
          <v-text-field
            type="password"
            v-model=" form.password_confirmation"
            :counter="60"
            :error-messages="errors"
            :label="$t('fields.confirm_password')"
          ></v-text-field>
        </ValidationProvider>
      </v-card-text>
      <v-card-actions>
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="loading"
          color="primary"
        >
          {{ $t('CHANGE_PASSWORD') }}
        </v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex';

  import { passwordService } from '../../utils/services/password.service';

  export default {
    name: 'ChangePassword',
    data() {
      return {
        loading: false,
        form: {
          current_password: null,
          password: null,
          password_confirmation: null,
        },
      };
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      async changePassword() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          this.loading = true;
          passwordService.change(this.form)
            .then(() => {
              this.showToast({ type: 'success', message: this.$t('PASSWORD_CHANGED') });
              this.form = {
                current_password: null,
                password: null,
                password_confirmation: null,
              };
              this.$refs.form.reset();
            })
            .catch(error => {
              this.handleError(error, this.$refs.form);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
    },
  };
</script>

<style scoped>

</style>
